import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const seatMap = {
  state: {
    x: 0,
    y: 0,
    buttonType: "",
    selectedList: [],
    templateId: null,
    templateName: null,
    confirmButtonLoading: false,
    reset: false
  },
  mutations: {
    changeX(state, x) {
      state.x = x;
    },
    changeY(state, y) {
      state.y = y;
    },
    changeXY(state, { x, y }) {
      state.x = x;
      state.y = y;
    },
    setSelectedList(state, selectedList) {
      state.selectedList = selectedList;
    },
    changeButtonType(state, buttonType) {
      state.buttonType = buttonType;
    },
    changetemplateId(state, templateId) {
      state.templateId = templateId;
    },
    changetemplateName(state, templateName) {
      state.templateName = templateName;
    },
    changeConfirmButtonLoading(state, confirmButtonLoading) {
      state.confirmButtonLoading = confirmButtonLoading;
    },
    changeReset(state, reset) {
      state.reset = reset;
    }
  },
  actions: {
    clearHallSeat({ commit }) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          commit("changeX", 0);
          commit("changeY", 0);
          commit("changetemplateName", null);
          commit("changeConfirmButtonLoading", false);
          commit("changeReset", false);
          resolve();
        }, 16);
      });
    }
  },
  getters: {}
};

export default new Vuex.Store({
  modules: {
    seatMap
  }
});
